import React from 'react';
import { StyleProp, TouchableOpacity, View } from 'react-native';

type Props = TouchableOpacity['props'] & {
  disabled?: boolean;
};

const Touchable: React.FC<Props> = (props) => {
  if (props.disabled) {
    <View {...props}>{props.children}</View>;
  }
  return (
    <TouchableOpacity activeOpacity={0.8} {...props}>
      {props.children}
    </TouchableOpacity>
  );
};

export default Touchable;
